<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ThePlugin',
}
</script>

<style scoped></style>
